import { createReducer } from '@reduxjs/toolkit';
import { setStores, setSelectedStore, logoutUser, storePermanentlyRemoved } from './actions';

const initialState = {
  stores: [],
  selectedStore: null,
  storesLoaded: false,
};

export const storesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setStores, (state, action) => {
      state.stores = action.payload;
      state.storesLoaded = true;
    })
    .addCase(setSelectedStore, (state, action) => {
      state.selectedStore = action.payload;
    })
    .addCase(storePermanentlyRemoved, (state, action) => {
      state.stores = state.stores.filter((store) => store.storeId !== action.payload);
      if (state.selectedStore?.storeId === action.payload) state.selectedStore = null;
    })
    .addCase(logoutUser, () => {
      return initialState;
    });
});
